export default "__VITE_ASSET__491d24b5__"